import { useCallback } from 'react';
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@monksflow/monks-ui';
import { LinkIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { notificationService } from '@/lib/services/notification.service';

/**
 * Copies a deep link to whatever the viewer is currently looking at.
 *
 * Reads `window.location.href` rather than rebuilding the URL from route params
 * because the query string carries the parts a reader most wants to share — the
 * selected version and any focused comment.
 */
export function CopyAssetLinkButton() {
  const { t } = useTranslation('projects');
  const label = t('projectDetail.assetDetailHeader.copyCurrentUrl');

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      notificationService.showSuccess(t('projectDetail.assetDetailHeader.linkCopied'));
    } catch {
      notificationService.showError(t('projectDetail.assetDetailHeader.failedToCopyLink'));
    }
  }, [t]);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="ghost" size="icon-lg" onClick={() => void handleCopy()} aria-label={label}>
          <LinkIcon className="size-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">{label}</TooltipContent>
    </Tooltip>
  );
}
